import { useContext } from "react";
import { PaymentContext, type PaymentContextValue } from "./PaymentContext";

export function usePayment(): PaymentContextValue {
  const ctx = useContext(PaymentContext);
  if (!ctx) {
    throw new Error("usePayment must be used within a PaymentProvider");
  }
  return ctx;
}
